import React from 'react';
import { Helmet } from 'react-helmet';

function MetaHeader({ pageTitle, description }) {
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
      <meta name="theme-color" content="#000000" />
    </Helmet>
  );
}

export default MetaHeader;
